import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_INVESTMENT_PROJECTS_YEARS = 'ppis/investment/projects/years';

export default class PPIInvestmentProjectYearService extends SfpBaseService {

  static updatePPIInvestmentProjectYear(year_id, property, value) {
		var values = {}
		values[property] = value
    const body = JSON.stringify({ppi_investment_project_year: values});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${year_id}/investment/project/year`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-investment-project-year-service.js